import { render, staticRenderFns } from "./MedChatComponent.vue?vue&type=template&id=55589b5c"
import script from "./MedChatComponent.vue?vue&type=script&lang=js"
export * from "./MedChatComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports